module.exports = __webpack_public_path__ + "img/Data-Blog-Size-1024x546.95be5eb7.png";